exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".arrival_time[data-v-4a0d4932]{padding:5px 10px;margin:0 10px;border-radius:3px}div[data-v-4a0d4932]{width:60%;margin:auto;padding:30px 0}button[data-v-4a0d4932]{transition:all .3s}@media screen and (max-width:768px){div[data-v-4a0d4932]{width:95%}h1[data-v-4a0d4932]{font-size:24px}small[data-v-4a0d4932]{display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a0d4932","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BookLot.vue
// module id = 689
// module chunks = 0